<script>
import StrapSearch from '@phoenix/mixins/components/strap-search/StrapSearch';
import FindWatchReferenceWidgetMixin from '@maison/mixins/FindWatchReferenceWidgetMixin';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: { PhxIcon },

  mixins: [StrapSearch, FindWatchReferenceWidgetMixin],

  props: {
    contactPageHref: {
      type: String,
      required: true,
    },
  },

  computed: {
    hasError() {
      return this.isOnResultPage && this.watchReference && !this.hasResult && !this.isLoading;
    },
  },

  methods: {
    async getStraps() {
      if (this.watchReference) {
        await this.getStrapFromWatchReference();
      } else {
        await this.getAllStraps();
      }

      if (!this.hasResult) {
        await this.getAllStraps();
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="onSubmit">
    <div class="strap-form">
      <div class="strap-form__text">
        {{ $t('StrapSearch.findAdaptedStraps') }}
        <template v-if="findWatchReferenceModalId">
          <button
            class="link link--text text-white"
            data-modal-open="strap-size-guide"
            type="button"
            @click.prevent="openFindWatchReferenceModal"
          >
            {{ $t('StrapSearch.referenceNumber') }}
          </button>
          <phx-icon class="ico--small" icon="info" />
        </template>
        <template v-else>
          {{ $t('StrapSearch.referenceNumber') }}
        </template>
      </div>

      <input
        v-model="searchValue"
        type="text"
        :class="['input input--fluid strap-form__input', { 'input--error': hasError }]"
        data-cy="search-enter-ref-input"
        :placeholder="$t('StrapSearch.exampleRefNumber')"
        autocorrect="off"
      />
      <div class="sgphx">
        <button class="sgphx-btn sgphx-btn--primary" data-cy="search-enter-ref-button">
          <span class="sgphx-btn__text">
            <span>{{ $t('Accessibility.search.label') }}</span>
          </span>
        </button>
      </div>

      <template v-if="hasError && !watchExists">
        <div class="strap-form__text scrim text-status-danger" data-cy="strap-search-no-result">
          {{ $t('StrapSearch.noResultNoWatch') }}
        </div>

        <div class="sgphx">
          <a :href="contactPageHref" class="sgphx-btn sgphx-btn--primary">
            <span class="sgphx-btn__text">
              <span>{{ $t('StrapSearch.contactUs') }}</span>
            </span>
          </a>
        </div>
      </template>
      <template v-else-if="hasError">
        <div class="strap-form__text scrim text-status-danger" data-cy="strap-search-no-result">
          {{ $t('StrapSearch.noResult') }}
        </div>

        <div class="sgphx">
          <a :href="contactPageHref" class="sgphx-btn sgphx-btn--primary">
            <span class="sgphx-btn__text">
              <span>{{ $t('StrapSearch.contactUs') }}</span>
            </span>
          </a>
        </div>
      </template>
    </div>
  </form>
</template>
